// import React, { useState, useEffect } from "react";
// import Spinner from "react-bootstrap/Spinner";
// import Modal from "react-bootstrap/Modal";
// import Lottie from "lottie-react";
// import notfoundData from "../../assets/not_found.json";
// import {
//   IconCreditCard,
//   IconTrash,
//   IconPencil,
//   IconBrandVisa,
//   IconEye,
//   IconTrendingUp2,
//   IconEdit,
// } from "@tabler/icons-react";
// import {
//   Form,
//   Row,
//   Col,
//   InputGroup,
//   FormText,
//   Card,
//   Button,
// } from "react-bootstrap";
// import "./Contact.css";
// import shapes from "../../assets/bg_card.svg";
// import { toast } from "react-toastify";
// import usePostRequest from "../../hooks/usePostRequest";
// import { API_ENDPOINTS } from "../../constant/_constant";
// import { useSelector } from "react-redux";
// import ComanConfirmationModal from "../../components/ComanConfirmationModal";
// import OtpVerifyPopup from "./OtpVerifyPopup";
// import CustomerCardEdit from "./CustomerCardEdit";

// function CustomerCard({ primary_email, show, setShow, auto_id }) {
//   const user = useSelector((state) => state.auth.user);
//   const canEditCards = user?.permissions?.manage_cards?.includes("write");
//   const canViewCards = user?.permissions?.manage_cards?.includes("read");
//   const canDeleteCards = user?.permissions?.manage_cards?.includes("delete");

//   const [cardDetails, setCardDetails] = useState({
//     cardHolderName: "",
//     cardNumber: "",
//     expiry: "",
//     cvc: "",
//     address: "",
//   });

//   const [errors, setErrors] = useState({
//     cardHolderName: "",
//     cardNumber: "",
//     expiry: "",
//     cvc: "",
//     address: "",
//   });

//   const [isModalOpen, setIsModalOpen] = useState({
//     show: false,
//     action: null,
//     message: "",
//   });

//   const validateCardHolderName = (value) => {
//     const regex = /^[A-Za-z\s]+$/;
//     return regex.test(value);
//   };
//   // const validateCardHolderName = (value) => {
//   //   const regex = /^[A-Za-z]+$/;
//   //   return regex.test(value);
//   // };

//   const validateCardNumber = (value) => {
//     const regex = /^[0-9]{15,16}$/;
//     return regex.test(value);
//   };
//   const validateExpiry = (value) => {
//     const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
//     return regex.test(value);
//   };

//   const validateCVC = (value) => {
//     if (!value || value.trim() === "") return true; // ✅ allow empty
//     const regex = /^\d{3}$/;
//     return regex.test(value);
//   };

//   // const validateCVC = (value) => {
//   //   const regex = /^\d{3}$/;
//   //   return regex.test(value);
//   // };

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     let validationError = "";
//     let formattedValue = value.replace(/\D/g, "");

//     if (value.trim() === "") {
//       validationError = `${name} is required`;
//     }

//     if (name === "cardNumber") {
//       if (formattedValue.length > 16) {
//         formattedValue = formattedValue.slice(0, 16);
//       }
//       formattedValue = formattedValue.replace(/(.{4})(?=.)/g, "$1 ");

//       if (!validateCardNumber(formattedValue.replace(/\D/g, ""))) {
//         validationError = "Card number must be 15 or 16 digits";
//       }
//     }

//     if (name === "expiry") {
//       if (formattedValue.length >= 3) {
//         formattedValue =
//           formattedValue.slice(0, 2) + "/" + formattedValue.slice(2, 4);
//       }

//       if (!validateExpiry(formattedValue)) {
//         validationError = "Expiry must be in MM/YY format";
//       }
//     }

//     if (name === "cvc") {
//       formattedValue = formattedValue.slice(0, 3);
//       if (formattedValue && !validateCVC(formattedValue)) {
//         validationError = "CVC must be 3 digits";
//       }
//       // if (!validateCVC(formattedValue)) {
//       //   validationError = "CVC must be 3 digits";
//       // }
//     }

//     if (name === "address") {
//       formattedValue = value;
//       validationError = ""; // optional field, no validation
//     }

//     // if (name === "cvv") {
//     //   if (!validateCVV(value)) {
//     //     validationError = "CVV must be 3 digits";
//     //   }
//     // }

//     if (name === "cardHolderName") {
//       if (!validateCardHolderName(value)) {
//         validationError = "Cardholder name can only contain letters";
//       }
//       formattedValue = value;
//     }

//     setCardDetails({
//       ...cardDetails,
//       [name]: formattedValue,
//     });

//     setErrors({
//       ...errors,
//       [name]: validationError,
//     });
//   };

//   const [addCard, setAddCard] = useState(false);
//   const [getCard, setGetCard] = useState(false);

//   const handleCancel = () => {
//     setAddCard(false);
//     setGetCard(false);
//     setCardDetails({ cardHolderName: "", cardNumber: "", expiry: "" });
//     setErrors({ cardHolderName: "", cardNumber: "", expiry: "" });
//     // setGetCardDetails({ email: "" });
//     setGetCardErrors({ email: "" });
//   };

//   const handleAddCardClick = (e) => {
//     // e.preventDefault();
//     setAddCard(true);
//   };

//   const handleGetCardClick = (e) => {
//     // e.preventDefault();
//     setGetCard(true);
//   };

//   const { isLoading, postData } = usePostRequest(
//     API_ENDPOINTS.CREATE_CARD_INFO
//   );

//   const { isLoading: isLoadingGetCard, postData: postGetCard } = usePostRequest(
//     API_ENDPOINTS.VERIFY_CUSTOMER_EMAIL
//   );

//   const { isLoading: deleteLoading, postData: DeleteCard } = usePostRequest(
//     API_ENDPOINTS.DELETE_CARD_INFO
//   );

//   const {
//     isLoading: Verifying,
//     postData: VerifyCustomerOtp,
//     data: Verified,
//   } = usePostRequest(API_ENDPOINTS.SEND_OTP_CARDS);

//   const {
//     data: cardData,
//     isLoadingCard,
//     postData: fetchCard,
//   } = usePostRequest(API_ENDPOINTS.GET_CARD_INFO);

//   const onSuccess = (response) => {
//     fetchCard({ auto_id: auto_id });
//     toast.success(response?.message);
//     setAddCard(false);
//     setCardDetails({ cardHolderName: "", cardNumber: "", expiry: "" });
//     setErrors({ cardHolderName: "", cardNumber: "", expiry: "" });
//   };

//   const [getCardDetails, setGetCardDetails] = useState({ email: "" });
//   const [getCardErrors, setGetCardErrors] = useState({ email: "" });

//   const validateEmail = (value) => {
//     const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return regex.test(value);
//   };

//   const handleGetCardChange = (e) => {
//     const { name, value } = e.target;
//     let error = "";

//     if (value.trim() === "") {
//       error = `${name} is required`;
//     } else if (name === "email" && !validateEmail(value)) {
//       error = "Invalid email address";
//     }

//     setGetCardDetails({ ...getCardDetails, [name]: value });
//     setGetCardErrors({ ...getCardErrors, [name]: error });
//   };

//   useEffect(() => {
//     if (primary_email) {
//       try {
//         let parsedEmail;
//         if (typeof primary_email === "string") {
//           try {
//             parsedEmail = JSON.parse(primary_email).Address;
//           } catch (error) {
//             parsedEmail = primary_email;
//           }
//         } else {
//           parsedEmail = primary_email.Address;
//         }

//         setGetCardDetails({ email: parsedEmail });
//       } catch (error) {
//         console.error("Failed to parse primary_email:", error);
//       }
//     }
//   }, [primary_email]);

//   // useEffect(() => {
//   //   if (primary_email) {
//   //     try {
//   //       const parsedEmail = JSON.parse(primary_email).Address;
//   //       console.log("Primary email:", parsedEmail);
//   //       setGetCardDetails({ email: parsedEmail });
//   //     } catch (error) {
//   //       console.error("Failed to parse primary_email:", error);
//   //     }
//   //   }
//   // }, [primary_email]);

//   const handleGetCardSubmit = (e) => {
//     e.preventDefault();
//     const isValid =
//       getCardDetails.email.trim() !== "" && getCardErrors.email === "";

//     if (!isValid) {
//       toast.error("Please correct the email before submitting");
//       return;
//     }

//     const payload = {
//       auto_id,
//       email: getCardDetails.email,
//     };

//     postGetCard(
//       payload,
//       (res) => {
//         toast.success(res?.message);
//         fetchCard({ auto_id });
//         setGetCard(false);
//         setGetCardDetails({ email: "" });
//         setGetCardErrors({ email: "" });
//       },
//       (err) => {
//         toast.error(err?.message || "Failed to get card");
//       }
//     );
//   };

//   const onError = (error) => {
//     toast.error(error?.message);
//   };
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Check if all fields are filled
//     // const formIsValid =
//     //   Object.values(errors).every((error) => error === "") &&
//     //   Object.values(cardDetails).every((value) => value.trim() !== "");

//     const formIsValid =
//       Object.values(errors).every((error) => error === "") &&
//       cardDetails.cardHolderName?.trim() !== "" &&
//       cardDetails.cardNumber?.trim() !== "" &&
//       cardDetails.expiry?.trim() !== "";

//     if (formIsValid) {
//       console.log("Form submitted", cardDetails);
//       const payload = {
//         auto_id: auto_id,
//         info_number: cardDetails.cardNumber.replace(/\s+/g, ""),
//         info_expiry: cardDetails.expiry,
//         info_name: cardDetails.cardHolderName,
//         cvc_code: cardDetails.cvc || null,
//         address: cardDetails.address || null
//       };
//       postData(payload, onSuccess, onError);
//     } else {
//       console.log("Please fix the errors before submitting");
//     }
//   };

//   useEffect(() => {
//     fetchCard({ auto_id: auto_id });
//   }, [auto_id]);

//   // OTP_Form

//   const [otpData, setOtpData] = useState({});
//   const [timer, setTimer] = useState({});
//   const [otpInput, setOtpInput] = useState({});
//   const [isOtpVisible, setIsOtpVisible] = useState({});
//   const [flippedCardIndex, setFlippedCardIndex] = useState(null);
//   const [showOtpPopup, setShowOtpPopup] = useState(false);
//   const [showCardDetails, setShowCardDetails] = useState(false);
//   const [verifiedCardData, setVerifiedCardData] = useState(null);

//   const handleDeleteClick = (index) => {
//     if (flippedCardIndex === index) {
//       setFlippedCardIndex(null);
//     } else {
//       setFlippedCardIndex(index);
//     }
//   };

//   const onSuccessDelete = (res) => {
//     fetchCard({ auto_id: auto_id });
//     toast.success(res?.message);
//     setFlippedCardIndex(null);
//   };

//   const onErrorDel = (error) => {
//     toast.error(error?.message);
//   };

//   const handleDelete = (id) => {
//     DeleteCard({ id: id }, onSuccessDelete, onErrorDel);
//   };

//   const handleEyeClick = (cardId) => {
//     setIsOtpVisible((prev) => ({ ...prev, [cardId]: true }));
//     startTimer(cardId);
//   };

//   const handleOtpChange = (e, cardId, index) => {
//     const value = e.target.value;
//     if (value && value.length === 1) {
//       setOtpInput((prevState) => {
//         const newOtpInput = { ...prevState };
//         newOtpInput[cardId] = [...(newOtpInput[cardId] || [])];
//         newOtpInput[cardId][index] = value;
//         return newOtpInput;
//       });

//       if (index < 5) {
//         document.getElementById(`otp-input-${cardId}-${index + 1}`).focus();
//       }
//     }
//   };

//   const handleKeyDown = (e, cardId, index) => {
//     // Handle backspace to focus previous input
//     if (e.key === "Backspace" && index > 0 && !otpInput[cardId]?.[index]) {
//       document.getElementById(`otp-input-${cardId}-${index - 1}`).focus();
//     }
//   };

//   const startTimer = (cardId) => {
//     const countdownTimer = 2 * 60; // 2 minutes in seconds
//     setTimer((prev) => ({ ...prev, [cardId]: countdownTimer }));

//     const intervalId = setInterval(() => {
//       setTimer((prevTimer) => {
//         const newTimer = { ...prevTimer };
//         if (newTimer[cardId] > 0) {
//           newTimer[cardId] -= 1;
//         } else {
//           clearInterval(intervalId);
//         }
//         return newTimer;
//       });
//     }, 1000);
//   };
//   const handleSubmitOtp = (e, cardId) => {
//     e.preventDefault();
//     const otpValue = Object.values(otpInput[cardId] || {}).join("");
//     if (otpValue.length === 6) {
//       alert(`OTP Submitted for Card: ${cardId} => ${otpValue}`);
//       setIsOtpVisible((prev) => ({ ...prev, [cardId]: false }));
//     } else {
//       alert("Please enter a valid 6-digit OTP.");
//     }
//   };

//   const onSuccessVerify = (res) => {
//     console.log("res pf send otp", res);
//     toast.success(res?.message);
//     // GetPackigSlip({ order_id: orderId });
//     setShowOtpPopup(true);
//   };

//   const onErrorVerify = (err) => {
//     toast.error(err?.message || "Failed to delete record");
//   };

//   // OTP_Form
//   const openModal = (id) => {
//     let modalMessage =
//       "Are you sure you want to edit customer's card details? An OTP will be sent for verification if you proceed.";
//     let modalTitle = "Edit Customer Card Details";
//     let type = "info";
//     let modalIcon = <IconCreditCard />;
//     let action = "success";

//     const handleSendOtp = () => {
//       VerifyCustomerOtp({ id }, onSuccessVerify, onErrorVerify);
//       setIsModalOpen({ ...isModalOpen, show: false });
//     };

//     setIsModalOpen({
//       show: true,
//       action,
//       message: modalMessage,
//       onConfirm: handleSendOtp,
//       title: modalTitle,
//       icon: modalIcon,
//       type,
//     });
//   };

//   const handleOtpVerified = (verifiedResponse) => {
//     setVerifiedCardData(verifiedResponse);
//     setShowOtpPopup(false);
//     setShowCardDetails(true);
//   };

//   console.log("cardDatacardData", cardData)

//   return (
//     <>
//       {showCardDetails && (
//         <CustomerCardEdit
//           show={showCardDetails}
//           onClose={() => setShowCardDetails(false)}
//           formData={verifiedCardData}
//         />
//       )}
//       {showOtpPopup && (
//         <OtpVerifyPopup
//           show={showOtpPopup}
//           onClose={() => setShowOtpPopup(false)}
//           formData={Verified}
//           onVerified={handleOtpVerified}
//         />
//       )}
//       <ComanConfirmationModal
//         show={isModalOpen.show}
//         onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
//         title={isModalOpen.title}
//         message={isModalOpen.message}
//         onConfirm={isModalOpen.onConfirm}
//         icon={isModalOpen.icon}
//         type={isModalOpen.type}
//       />
//       <Modal
//         scrollable={true}
//         dialogClassName="modal-90w"
//         size="lg"
//         show={show}
//         onHide={() => setShow({ show: false })}
//         aria-labelledby="example-custom-modal-styling-title"
//       >
//         <Modal.Header
//           className="gap-2 justify-content-between pe-5"
//           closeButton
//         >
//           <div className="d-flex align-items-center gap-2">
//             <span className="avatar bg-indigo-lt rounded-circle">
//               <IconCreditCard />
//             </span>
//             <Modal.Title>Payment Details</Modal.Title>
//           </div>
//           <div className="d-flex gap-3">
//             <span
//               className="add_new_card bg-indigo"
//               style={{ cursor: !canViewCards ? "not-allowed" : "pointer" }}
//               onClick={(e) => {
//                 e.preventDefault();
//                 if (canViewCards) {
//                   handleGetCardClick();
//                 }
//               }}
//             >
//               Get Card
//             </span>
//             <span
//               className="add_new_card bg-indigo"
//               style={{ cursor: !canEditCards ? "not-allowed" : "pointer" }}
//               onClick={(e) => {
//                 e.preventDefault();
//                 if (canEditCards) {
//                   handleAddCardClick();
//                 }
//               }}
//             >
//               Add Card
//             </span>
//           </div>
//         </Modal.Header>
//         <Modal.Body>
//           <Row className="justify-content-center">
//             <Col md={11}>
//               {addCard && (
//                 <Card className="add_credit_card mb-3">
//                   <Card.Header className="card_header">
//                     ADD NEW CARD
//                   </Card.Header>
//                   <Card.Body>
//                     <Form onSubmit={handleSubmit}>
//                       <Row>
//                         <Col md={12}>
//                           <Form.Group className="mb-3">
//                             <Form.Label className="required">
//                               CARDHOLDER NAME
//                             </Form.Label>
//                             <InputGroup>
//                               <Form.Control
//                                 name="cardHolderName"
//                                 value={cardDetails.cardHolderName}
//                                 onChange={handleChange}
//                                 placeholder="Enter Cardholder Name"
//                               />
//                             </InputGroup>
//                             {errors.cardHolderName && (
//                               <div className="text-danger">
//                                 {errors.cardHolderName}
//                               </div>
//                             )}
//                           </Form.Group>
//                         </Col>
//                         <Col md={6}>
//                           <Form.Group className="mb-3">
//                             <Form.Label className="required">
//                               CARD NUMBER
//                             </Form.Label>
//                             <InputGroup>
//                               <InputGroup.Text>
//                                 <IconBrandVisa stroke={1} />
//                               </InputGroup.Text>
//                               <Form.Control
//                                 name="cardNumber"
//                                 value={cardDetails.cardNumber}
//                                 onChange={handleChange}
//                                 type="text"
//                                 placeholder="**** **** **** ****"
//                               />
//                             </InputGroup>
//                             {errors.cardNumber && (
//                               <div className="text-danger">
//                                 {errors.cardNumber}
//                               </div>
//                             )}
//                           </Form.Group>
//                         </Col>
//                         <Col md={3}>
//                           <Form.Group className="mb-3">
//                             <Form.Label className="required">EXPIRY</Form.Label>
//                             <InputGroup>
//                               <Form.Control
//                                 name="expiry"
//                                 value={cardDetails.expiry}
//                                 onChange={handleChange}
//                                 type="text"
//                                 placeholder="MM/YY"
//                                 maxLength={5}
//                                 onInput={(e) => {
//                                   let value = e.target.value.replace(/\D/g, "");
//                                   if (value.length > 4) {
//                                     value = value.slice(0, 4);
//                                   }
//                                   if (value.length >= 3) {
//                                     value =
//                                       value.slice(0, 2) +
//                                       "/" +
//                                       value.slice(2, 4);
//                                   }
//                                   e.target.value = value;
//                                 }}
//                               />
//                             </InputGroup>
//                             {errors.expiry && (
//                               <div className="text-danger">{errors.expiry}</div>
//                             )}
//                           </Form.Group>
//                         </Col>
//                         <Col md={3}>
//                           <Form.Group className="mb-3">
//                             <Form.Label className="">
//                               CVC CODE
//                             </Form.Label>
//                             <InputGroup>
//                               <Form.Control
//                                 name="cvc"
//                                 value={cardDetails.cvc}
//                                 onChange={handleChange}
//                                 type="password"
//                                 maxLength={3}
//                                 placeholder="123"
//                               />
//                             </InputGroup>
//                             {errors.cvc && (
//                               <div className="text-danger">{errors.cvc}</div>
//                             )}
//                           </Form.Group>
//                         </Col>
//                         <Col md={12}>
//                           <Form.Group className="mb-3">
//                             <Form.Label>ADDRESS</Form.Label>
//                             <InputGroup>
//                               <Form.Control
//                                 name="address"
//                                 value={cardDetails.address}
//                                 onChange={handleChange}
//                                 placeholder="Enter address"
//                               />
//                             </InputGroup>
//                           </Form.Group>
//                         </Col>

//                       </Row>
//                       <div className="d-flex justify-content-center gap-2">
//                         <Button
//                           type="submit"
//                           variant="warning"
//                           disabled={
//                             Object.values(errors).some(
//                               (error) => error !== ""
//                             ) ||
//                             cardDetails.cardHolderName.trim() === "" ||
//                             cardDetails.cardNumber.trim() === "" ||
//                             cardDetails.expiry.trim() === ""
//                             // Object.values(cardDetails).some(
//                             //   (value) => value.trim() === ""
//                             // )
//                           }
//                         >
//                           {isLoading ? (
//                             <Spinner
//                               as="span"
//                               animation="border"
//                               size="sm"
//                               role="status"
//                               aria-hidden="true"
//                             />
//                           ) : (
//                             "Submit"
//                           )}
//                         </Button>
//                         <Button
//                           type="button"
//                           variant="outline-secondary"
//                           onClick={handleCancel}
//                         >
//                           Cancel
//                         </Button>
//                       </div>
//                     </Form>
//                   </Card.Body>
//                 </Card>
//               )}

//               {getCard && (
//                 <Card className="add_credit_card mb-3">
//                   <Card.Header className="card_header">
//                     GET NEW CARD
//                   </Card.Header>
//                   <Card.Body>
//                     <Form onSubmit={handleGetCardSubmit}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="required">EMAIL</Form.Label>
//                         <Form.Control
//                           type="email"
//                           name="email"
//                           value={getCardDetails.email}
//                           onChange={handleGetCardChange}
//                           placeholder="Enter your email address"
//                         />
//                         {getCardErrors.email && (
//                           <div className="text-danger">
//                             {getCardErrors.email}
//                           </div>
//                         )}
//                       </Form.Group>
//                       <div className="d-flex justify-content-center gap-2">
//                         <Button
//                           type="submit"
//                           variant="primary"
//                           disabled={
//                             isLoadingGetCard ||
//                             getCardDetails.email.trim() === "" ||
//                             getCardErrors.email
//                           }
//                         >
//                           {isLoadingGetCard ? (
//                             <Spinner
//                               as="span"
//                               animation="border"
//                               size="sm"
//                               role="status"
//                               aria-hidden="true"
//                             />
//                           ) : (
//                             "Get Card"
//                           )}
//                         </Button>
//                         <Button
//                           type="button"
//                           variant="outline-secondary"
//                           onClick={handleCancel}
//                         >
//                           Cancel
//                         </Button>
//                       </div>
//                     </Form>
//                   </Card.Body>
//                 </Card>
//               )}

//               {!addCard && (
//                 <Row className="mb-4">
//                   {isLoadingCard ? (
//                     <Spinner animation="border" role="status">
//                       <span className="visually-hidden">Loading...</span>
//                     </Spinner>
//                   ) : cardData && cardData?.data.length > 0 ? (
//                     cardData?.data.map((card, index) => {
//                       const isFlipped = flippedCardIndex === index;
//                       return (
//                         <Col className="mb-4" md={6} key={index}>
//                           <div
//                             className={`payment_card_box card-container ${isFlipped ? "flipped" : ""
//                               }`}
//                           >
//                             <div
//                               className="position-relative"
//                               style={{ zIndex: "1" }}
//                             >
//                               <div className="payment_head">
//                                 <span className="payment_tittle">
//                                   Credit Card
//                                 </span>
//                                 <div className="d-flex flex-row gap-3">
//                                   <span className="">
//                                     <IconTrash
//                                       onClick={(e) => {
//                                         e.preventDefault();
//                                         if (canDeleteCards) {
//                                           handleDeleteClick(index);
//                                         }
//                                       }}
//                                       style={{
//                                         cursor: !canDeleteCards
//                                           ? "not-allowed"
//                                           : "pointer",
//                                       }}
//                                       stroke={1}
//                                     />
//                                   </span>
//                                   <span className="">
//                                     <IconEdit
//                                       onClick={(e) => {
//                                         e.preventDefault();
//                                         if (canEditCards) {
//                                           openModal(card?.id);
//                                         }
//                                       }}
//                                       style={{
//                                         cursor: !canEditCards
//                                           ? "not-allowed"
//                                           : "pointer",
//                                       }}
//                                       stroke={1}
//                                     />
//                                   </span>
//                                 </div>
//                               </div>
//                               <div className="chip">
//                                 <div className="chip-line" />
//                                 <div className="chip-line" />
//                                 <div className="chip-line" />
//                                 <div className="chip-line" />
//                                 <div className="chip-main" />
//                               </div>

//                               <h6 className="card_holder"> {card.info_name}</h6>
//                               <h6 className="card_numbers">
//                                 <span>****</span> <span>****</span>
//                                 <span>****</span> {card.info_number}
//                               </h6>
//                               {/* <span className="card_expiry">
//                               Expiry {card.info_expiry}
//                             </span> */}
//                             </div>
//                             <img src={shapes} />
//                           </div>

//                           {isFlipped && (
//                             <div className="payment_card_box_cnfirm">
//                               <div
//                                 className="position-relative"
//                                 style={{ zIndex: "1" }}
//                               >
//                                 <div>
//                                   <h6 className="cnfirm_heading text-center pt-3">
//                                     Are you sure?
//                                   </h6>
//                                 </div>
//                                 <div className="confirmation-buttons d-flex justify-content-center gap-2 pt-3">
//                                   <Button
//                                     variant="warning"
//                                     disabled={deleteLoading}
//                                     onClick={() => handleDelete(card.id)}
//                                   >
//                                     {deleteLoading ? (
//                                       <Spinner
//                                         as="span"
//                                         animation="border"
//                                         size="sm"
//                                         role="status"
//                                         aria-hidden="true"
//                                       />
//                                     ) : (
//                                       "Yes"
//                                     )}
//                                   </Button>
//                                   <Button
//                                     variant="outline-danger"
//                                     onClick={() => setFlippedCardIndex(null)}
//                                   >
//                                     Cancel
//                                   </Button>
//                                 </div>
//                               </div>
//                               <img src={shapes} alt="Card shape" />
//                             </div>
//                           )}
//                         </Col>
//                       );
//                     })
//                   ) : (
//                     <div className="data_not_available text-center">
//                       {" "}
//                       <Lottie animationData={notfoundData} />{" "}
//                       <p> No Card available.</p>{" "}
//                     </div>
//                   )}
//                 </Row>
//               )}
//             </Col>
//           </Row>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// }

// export default CustomerCard;

import React, { useState, useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import Lottie from "lottie-react";
import notfoundData from "../../assets/not_found.json";
import {
  IconCreditCard,
  IconTrash,
  IconBrandVisa,
  IconEdit,
  IconCurrencyDollar,
} from "@tabler/icons-react";
import { Form, Row, Col, InputGroup, Card, Button } from "react-bootstrap";
import "./Contact.css";
import shapes from "../../assets/bg_card.svg";
import { toast } from "react-toastify";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { useSelector } from "react-redux";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import OtpVerifyPopup from "./OtpVerifyPopup";
import CustomerCardEdit from "./CustomerCardEdit";
import { usePostHog } from "@posthog/react";

function CustomerCard({ primary_email, show, setShow, auto_id }) {
  const user = useSelector((state) => state.auth.user);
  const canEditCards = user?.permissions?.manage_cards?.includes("write");
  const canViewCards = user?.permissions?.manage_cards?.includes("read");
  const canDeleteCards = user?.permissions?.manage_cards?.includes("delete");
  const posthog = usePostHog();
  const [cardDetails, setCardDetails] = useState({
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvc: "",
    invoiceNumber: "",
    amount: "",
    address: "",
    zipCode: "",
    notes: "",
  });

  const [errors, setErrors] = useState({
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvc: "",
    invoiceNumber: "",
    amount: "",
    address: "",
    zipCode: "",
    notes: "",
  });

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const validateCardHolderName = (value) => {
    const regex = /^[A-Za-z\s]+$/;
    return regex.test(value);
  };

  const validateCardNumber = (value) => {
    const regex = /^[0-9]{15,16}$/;
    return regex.test(value);
  };

  const validateExpiry = (value) => {
    const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
    return regex.test(value);
  };

  const validateCVC = (value) => {
    if (!value || value.trim() === "") return true;
    const regex = /^\d{3,4}$/;
    return regex.test(value);
  };

  const validateZipCode = (value) => /^\d{5,9}$/.test(value);
  const validateAmount = (value) => !isNaN(value) && parseFloat(value) > 0;
  const handleChange = (e) => {
    const { name, value } = e.target;

    let validationError = "";
    let formattedValue = value;

    switch (name) {
      case "cardNumber": {
        const digits = value.replace(/\D/g, "").slice(0, 16);
        formattedValue = digits.replace(/(.{4})(?=.)/g, "$1 ");
        if (value.trim() === "") validationError = "Card number is required";
        else if (!validateCardNumber(digits))
          validationError = "Card number must be 15 or 16 digits";
        break;
      }

      case "invoiceNumber": {
        formattedValue = value;
        if (value.trim() === "") validationError = "Invoice number is required";
        break;
      }

      case "amount": {
        formattedValue = value;
        if (value.trim() === "") validationError = "Amount is required";
        else if (!validateAmount(value))
          validationError = "Amount must be a positive number";
        break;
      }

      case "expiry": {
        const digits = value.replace(/\D/g, "").slice(0, 4);
        formattedValue =
          digits.length >= 3
            ? `${digits.slice(0, 2)}/${digits.slice(2)}`
            : digits;
        if (value.trim() === "") validationError = "Expiry is required";
        else if (!validateExpiry(formattedValue))
          validationError = "Expiry must be in MM/YY format";
        break;
      }

      case "cvc": {
        formattedValue = value.replace(/\D/g, "").slice(0, 4);
        if (formattedValue && !validateCVC(formattedValue))
          validationError = "CVC must be 3 or 4 digits";
        break;
      }

      case "zipCode": {
        formattedValue = value.replace(/\D/g, "").slice(0, 9);
        if (formattedValue.trim() === "")
          validationError = "ZIP Code is required";
        else if (!validateZipCode(formattedValue))
          validationError = "ZIP code must be 5–9 digits";
        break;
      }

      case "cardHolderName": {
        formattedValue = value;
        if (value.trim() === "")
          validationError = "Cardholder name is required";
        else if (!validateCardHolderName(value))
          validationError =
            "Cardholder name can only contain letters and spaces";
        break;
      }

      // address and notes: optional, no validation
      default:
        formattedValue = value;
        break;
    }

    setCardDetails({ ...cardDetails, [name]: formattedValue });
    setErrors({ ...errors, [name]: validationError });
  };

  const [addCard, setAddCard] = useState(false);
  const [getCard, setGetCard] = useState(false);

  const handleCancel = () => {
    setAddCard(false);
    setGetCard(false);
    setCardDetails({
      cardHolderName: "",
      cardNumber: "",
      expiry: "",
      cvc: "",
      invoiceNumber: "",
      amount: "",
      address: "",
      zipCode: "",
      notes: "",
    });
    setErrors({
      cardHolderName: "",
      cardNumber: "",
      expiry: "",
      cvc: "",
      address: "",
      invoiceNumber: "",
      amount: "",
      zipCode: "",
      notes: "",
    });
    setGetCardErrors({ email: "" });
  };

  const handleAddCardClick = () => setAddCard(true);
  const handleGetCardClick = () => setGetCard(true);

  const { isLoading, postData } = usePostRequest(
    API_ENDPOINTS.CREATE_CARD_INFO,
  );
  const { isLoading: isLoadingGetCard, postData: postGetCard } = usePostRequest(
    API_ENDPOINTS.VERIFY_CUSTOMER_EMAIL,
  );
  const { isLoading: deleteLoading, postData: DeleteCard } = usePostRequest(
    API_ENDPOINTS.DELETE_CARD_INFO,
  );
  const {
    isLoading: Verifying,
    postData: VerifyCustomerOtp,
    data: Verified,
  } = usePostRequest(API_ENDPOINTS.SEND_OTP_CARDS);
  const {
    data: cardData,
    isLoadingCard,
    postData: fetchCard,
  } = usePostRequest(API_ENDPOINTS.GET_CARD_INFO);

  const onSuccess = (response) => {
    posthog.capture("payment_details_added", {
      created_by: user?.email,
    });
    fetchCard({ auto_id });
    toast.success(response?.message);
    setAddCard(false);
    setCardDetails({
      cardHolderName: "",
      cardNumber: "",
      expiry: "",
      cvc: "",
      invoiceNumber: "",
      amount: "",
      address: "",
      zipCode: "",
      notes: "",
    });
    setErrors({
      cardHolderName: "",
      cardNumber: "",
      expiry: "",
      cvc: "",
      invoiceNumber: "",
      amount: "",
      address: "",
      zipCode: "",
      notes: "",
    });
  };

  const [getCardDetails, setGetCardDetails] = useState({ email: "" });
  const [getCardErrors, setGetCardErrors] = useState({ email: "" });

  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleGetCardChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (value.trim() === "") {
      error = `${name} is required`;
    } else if (name === "email" && !validateEmail(value)) {
      error = "Invalid email address";
    }
    setGetCardDetails({ ...getCardDetails, [name]: value });
    setGetCardErrors({ ...getCardErrors, [name]: error });
  };

  useEffect(() => {
    if (primary_email) {
      try {
        let parsedEmail;
        if (typeof primary_email === "string") {
          try {
            parsedEmail = JSON.parse(primary_email).Address;
          } catch (error) {
            parsedEmail = primary_email;
          }
        } else {
          parsedEmail = primary_email.Address;
        }
        setGetCardDetails({ email: parsedEmail });
      } catch (error) {
        console.error("Failed to parse primary_email:", error);
      }
    }
  }, [primary_email]);

  const handleGetCardSubmit = (e) => {
    e.preventDefault();
    const isValid =
      getCardDetails.email.trim() !== "" && getCardErrors.email === "";
    if (!isValid) {
      toast.error("Please correct the email before submitting");
      return;
    }
    postGetCard(
      { auto_id, email: getCardDetails.email },
      (res) => {
        toast.success(res?.message);
        fetchCard({ auto_id });
        setGetCard(false);
        setGetCardDetails({ email: "" });
        setGetCardErrors({ email: "" });
      },
      (err) => toast.error(err?.message || "Failed to get card"),
    );
  };

  const onError = (error) => toast.error(error?.message);

  const handleSubmit = (e) => {
    e.preventDefault();

    const formIsValid =
      Object.values(errors).every((error) => error === "") &&
      cardDetails.cardHolderName?.trim() !== "" &&
      cardDetails.cardNumber?.trim() !== "" &&
      cardDetails.expiry?.trim() !== "" &&
      cardDetails.zipCode?.trim() !== "" &&
      cardDetails.invoiceNumber?.trim() !== "" &&
      cardDetails.amount?.toString().trim() !== "";
    // const formIsValid =
    //   Object.values(errors).every((error) => error === "") &&
    //   cardDetails.cardHolderName?.trim() !== "" &&
    //   cardDetails.cardNumber?.trim() !== "" &&
    //   cardDetails.expiry?.trim() !== "" &&
    //   cardDetails.zipCode?.trim() !== "";

    if (formIsValid) {
      const payload = {
        auto_id,
        info_number: cardDetails.cardNumber.replace(/\s+/g, ""),
        info_expiry: cardDetails.expiry,
        info_name: cardDetails.cardHolderName,
        cvc_code: cardDetails.cvc || null,
        invoice_number: cardDetails.invoiceNumber,
        amount: cardDetails.amount,
        address: cardDetails.address || null,
        zip_code: cardDetails.zipCode,
        note: cardDetails.notes || null,
      };
      postData(payload, onSuccess, onError);
    } else {
      toast.error("Please fix all errors before submitting");
    }
  };

  useEffect(() => {
    fetchCard({ auto_id });
  }, [auto_id]);

  useEffect(() => {
    if (show) {
      posthog.stopSessionRecording();
    } else {
      posthog.startSessionRecording();
    }
  }, [show]);

  // OTP_Form
  const [otpData, setOtpData] = useState({});
  const [timer, setTimer] = useState({});
  const [otpInput, setOtpInput] = useState({});
  const [isOtpVisible, setIsOtpVisible] = useState({});
  const [flippedCardIndex, setFlippedCardIndex] = useState(null);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [verifiedCardData, setVerifiedCardData] = useState(null);

  const handleDeleteClick = (index) => {
    setFlippedCardIndex(flippedCardIndex === index ? null : index);
  };

  const onSuccessDelete = (res) => {
    fetchCard({ auto_id });
    toast.success(res?.message);
    setFlippedCardIndex(null);
  };

  const onErrorDel = (error) => toast.error(error?.message);

  const handleDelete = (id) => {
    DeleteCard({ id }, onSuccessDelete, onErrorDel);
  };

  const onSuccessVerify = (res) => {
    toast.success(res?.message);
    setShowOtpPopup(true);
  };

  const onErrorVerify = (err) => {
    toast.error(err?.message || "Failed to delete record");
  };

  const openModal = (id) => {
    const handleSendOtp = () => {
      VerifyCustomerOtp({ id }, onSuccessVerify, onErrorVerify);
      setIsModalOpen({ ...isModalOpen, show: false });
    };
    setIsModalOpen({
      show: true,
      action: "success",
      message:
        "Are you sure you want to edit customer's card details? An OTP will be sent for verification if you proceed.",
      onConfirm: handleSendOtp,
      title: "Edit Customer Card Details",
      icon: <IconCreditCard />,
      type: "info",
    });
  };

  const handleOtpVerified = (verifiedResponse) => {
    setVerifiedCardData(verifiedResponse);
    setShowOtpPopup(false);
    setShowCardDetails(true);
  };

  return (
    <>
      {showCardDetails && (
        <CustomerCardEdit
          show={showCardDetails}
          onClose={() => setShowCardDetails(false)}
          formData={verifiedCardData}
        />
      )}
      {showOtpPopup && (
        <OtpVerifyPopup
          show={showOtpPopup}
          onClose={() => setShowOtpPopup(false)}
          formData={Verified}
          onVerified={handleOtpVerified}
        />
      )}
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />

      <Modal
        scrollable={true}
        dialogClassName="modal-90w"
        size="lg"
        show={show}
        onHide={() => setShow({ show: false })}
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header
          className="gap-2 justify-content-between pe-5"
          closeButton
        >
          <div className="d-flex align-items-center gap-2">
            <span className="avatar bg-indigo-lt rounded-circle">
              <IconCreditCard />
            </span>
            <Modal.Title>Payment Details</Modal.Title>
          </div>
          <div className="d-flex gap-3">
            <span
              className="add_new_card bg-indigo"
              style={{ cursor: !canViewCards ? "not-allowed" : "pointer" }}
              onClick={(e) => {
                e.preventDefault();
                if (canViewCards) handleGetCardClick();
              }}
            >
              Get Card
            </span>
            <span
              className="add_new_card bg-indigo"
              style={{ cursor: !canEditCards ? "not-allowed" : "pointer" }}
              onClick={(e) => {
                e.preventDefault();
                if (canEditCards) handleAddCardClick();
              }}
            >
              Add Card
            </span>
          </div>
        </Modal.Header>

        <Modal.Body>
          <Row className="justify-content-center">
            <Col md={11}>
              {/* ── Add Card Section ─────────────────────────────────────── */}
              {addCard && (
                <Card className="add_credit_card mb-3">
                  <Card.Header className="card_header">
                    ADD NEW CARD
                  </Card.Header>
                  <Card.Body>
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        {/* Cardholder Name */}
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="required">
                              CARDHOLDER NAME
                            </Form.Label>
                            <InputGroup>
                              <Form.Control
                                name="cardHolderName"
                                value={cardDetails.cardHolderName}
                                onChange={handleChange}
                                placeholder="Enter Cardholder Name"
                                isInvalid={!!errors.cardHolderName}
                              />
                            </InputGroup>
                            {errors.cardHolderName && (
                              <div className="text-danger small">
                                {errors.cardHolderName}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        {/* Card Number */}
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="required">
                              CARD NUMBER
                            </Form.Label>
                            <InputGroup>
                              <InputGroup.Text>
                                <IconBrandVisa stroke={1} />
                              </InputGroup.Text>
                              <Form.Control
                                name="cardNumber"
                                value={cardDetails.cardNumber}
                                onChange={handleChange}
                                type="text"
                                placeholder="**** **** **** ****"
                                isInvalid={!!errors.cardNumber}
                              />
                            </InputGroup>
                            {errors.cardNumber && (
                              <div className="text-danger small">
                                {errors.cardNumber}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        {/* Expiry */}
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label className="required">EXPIRY</Form.Label>
                            <InputGroup>
                              <Form.Control
                                name="expiry"
                                value={cardDetails.expiry}
                                onChange={handleChange}
                                type="text"
                                placeholder="MM/YY"
                                maxLength={5}
                                isInvalid={!!errors.expiry}
                              />
                            </InputGroup>
                            {errors.expiry && (
                              <div className="text-danger small">
                                {errors.expiry}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        {/* CVC */}
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>CVC CODE</Form.Label>
                            <InputGroup>
                              <Form.Control
                                name="cvc"
                                value={cardDetails.cvc}
                                onChange={handleChange}
                                type="password"
                                maxLength={4}
                                placeholder="123"
                                isInvalid={!!errors.cvc}
                              />
                            </InputGroup>
                            {errors.cvc && (
                              <div className="text-danger small">
                                {errors.cvc}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        {/* ZIP Code */}
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label className="required">
                              ZIP CODE
                            </Form.Label>
                            <Form.Control
                              name="zipCode"
                              value={cardDetails.zipCode}
                              onChange={handleChange}
                              placeholder="90210"
                              isInvalid={!!errors.zipCode}
                            />
                            {errors.zipCode && (
                              <div className="text-danger small">
                                {errors.zipCode}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        {/* Address */}
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>ADDRESS</Form.Label>
                            <InputGroup>
                              <Form.Control
                                name="address"
                                value={cardDetails.address}
                                onChange={handleChange}
                                placeholder="Enter address"
                              />
                            </InputGroup>
                          </Form.Group>
                        </Col>

                        {/* Invoice Number */}
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="required">
                              INVOICE NUMBER
                            </Form.Label>
                            <Form.Control
                              name="invoiceNumber"
                              value={cardDetails.invoiceNumber}
                              onChange={handleChange}
                              placeholder="Enter Invoice Number"
                              isInvalid={!!errors.invoiceNumber}
                            />
                            {errors.invoiceNumber && (
                              <div className="text-danger small">
                                {errors.invoiceNumber}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        {/* Amount */}
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label className="required">AMOUNT</Form.Label>
                            <InputGroup>
                              <InputGroup.Text>
                                <IconCurrencyDollar stroke={2} />
                              </InputGroup.Text>
                              <Form.Control
                                name="amount"
                                value={cardDetails.amount}
                                onChange={handleChange}
                                type="number"
                                step="0.01"
                                min="0"
                                placeholder="Enter Amount"
                                isInvalid={!!errors.amount}
                              />
                            </InputGroup>
                            {errors.amount && (
                              <div className="text-danger small">
                                {errors.amount}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        {/* Notes */}
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>ADDITIONAL NOTES</Form.Label>
                            <Form.Control
                              name="notes"
                              value={cardDetails.notes}
                              onChange={handleChange}
                              placeholder="Enter notes"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          type="submit"
                          variant="warning"
                          disabled={
                            isLoading ||
                            Object.values(errors).some(
                              (error) => error !== "",
                            ) ||
                            cardDetails.cardHolderName.trim() === "" ||
                            cardDetails.cardNumber.trim() === "" ||
                            cardDetails.expiry.trim() === "" ||
                            cardDetails.zipCode.trim() === "" ||
                            cardDetails.invoiceNumber.trim() === "" ||
                            cardDetails.amount.toString().trim() === ""
                          }
                        >
                          {isLoading ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Submit"
                          )}
                        </Button>
                        <Button
                          type="button"
                          variant="outline-secondary"
                          onClick={handleCancel}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              )}

              {/* ── Get Card Section ─────────────────────────────────────── */}
              {getCard && (
                <Card className="add_credit_card mb-3">
                  <Card.Header className="card_header">
                    GET NEW CARD
                  </Card.Header>
                  <Card.Body>
                    <Form onSubmit={handleGetCardSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">EMAIL</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={getCardDetails.email}
                          onChange={handleGetCardChange}
                          placeholder="Enter your email address"
                        />
                        {getCardErrors.email && (
                          <div className="text-danger">
                            {getCardErrors.email}
                          </div>
                        )}
                      </Form.Group>
                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          type="submit"
                          variant="primary"
                          disabled={
                            isLoadingGetCard ||
                            getCardDetails.email.trim() === "" ||
                            !!getCardErrors.email
                          }
                        >
                          {isLoadingGetCard ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            "Get Card"
                          )}
                        </Button>
                        <Button
                          type="button"
                          variant="outline-secondary"
                          onClick={handleCancel}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              )}

              {/* ── Card Listing ─────────────────────────────────────────── */}
              {!addCard && (
                <Row className="mb-4">
                  {isLoadingCard ? (
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : cardData && cardData?.data.length > 0 ? (
                    cardData?.data.map((card, index) => {
                      const isFlipped = flippedCardIndex === index;
                      return (
                        <Col className="mb-4" md={6} key={index}>
                          <div
                            className={`payment_card_box card-container ${isFlipped ? "flipped" : ""}`}
                          >
                            <div
                              className="position-relative"
                              style={{ zIndex: "1" }}
                            >
                              <div className="payment_head">
                                <span className="payment_tittle">
                                  Credit Card
                                </span>
                                <div className="d-flex flex-row gap-3">
                                  <span>
                                    <IconTrash
                                      onClick={(e) => {
                                        e.preventDefault();
                                        if (canDeleteCards)
                                          handleDeleteClick(index);
                                      }}
                                      style={{
                                        cursor: !canDeleteCards
                                          ? "not-allowed"
                                          : "pointer",
                                      }}
                                      stroke={1}
                                    />
                                  </span>
                                  <span>
                                    <IconEdit
                                      onClick={(e) => {
                                        e.preventDefault();
                                        if (canEditCards) openModal(card?.id);
                                      }}
                                      style={{
                                        cursor: !canEditCards
                                          ? "not-allowed"
                                          : "pointer",
                                      }}
                                      stroke={1}
                                    />
                                  </span>
                                </div>
                              </div>
                              <div className="chip">
                                <div className="chip-line" />
                                <div className="chip-line" />
                                <div className="chip-line" />
                                <div className="chip-line" />
                                <div className="chip-main" />
                              </div>
                              <h6 className="card_holder">{card.info_name}</h6>
                              <h6 className="card_numbers">
                                <span>****</span> <span>****</span>{" "}
                                <span>****</span> {card.info_number}
                              </h6>
                            </div>
                            <img src={shapes} alt="Card background" />
                          </div>

                          {isFlipped && (
                            <div className="payment_card_box_cnfirm">
                              <div
                                className="position-relative"
                                style={{ zIndex: "1" }}
                              >
                                <h6 className="cnfirm_heading text-center pt-3">
                                  Are you sure?
                                </h6>
                                <div className="confirmation-buttons d-flex justify-content-center gap-2 pt-3">
                                  <Button
                                    variant="warning"
                                    disabled={deleteLoading}
                                    onClick={() => handleDelete(card.id)}
                                  >
                                    {deleteLoading ? (
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                      />
                                    ) : (
                                      "Yes"
                                    )}
                                  </Button>
                                  <Button
                                    variant="outline-danger"
                                    onClick={() => setFlippedCardIndex(null)}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                              <img src={shapes} alt="Card shape" />
                            </div>
                          )}
                        </Col>
                      );
                    })
                  ) : (
                    <div className="data_not_available text-center">
                      <Lottie animationData={notfoundData} />
                      <p>No Card available.</p>
                    </div>
                  )}
                </Row>
              )}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CustomerCard;
